import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Reza Eghbali</h1>
    </div>
  );
}

export default App;
